import { PageContentAnimation, WidgetsGrid } from '../../../components';
import { TotalEnergyConsumptionWidget } from './components/widgets/total-energy-consumption';
import { EnergyConsumptionKvmWidget } from './components/widgets/energy-consumption-kvm';
import { ConsumptionTrendAverageWidget } from './components/widgets/consumption-average-trend';
import { TopConsumptionWidget } from './components/widgets/top-consumption';
import { useTranslation } from 'react-i18next';
import { useRouteDocumentTitle } from '@client/toolkit';
import { DashboardPaths } from '../dashboard.router';
import { DashboardFilters } from '../components';
import { eosDateRangeFilterVisiblePresets } from '../../../components/eos/config';
import { EstimatedEnergyCostWidget } from './components/widgets/estimated-energy-cost';
import { EstimatedEnergyCostSpacesWidget } from './components/widgets/estimated-cost-spaces';

export function DashboardEnergyViewRoute() {
  const { t: routeT } = useTranslation('dashboard');
  useRouteDocumentTitle(routeT('dashboard.energy.documentTitle'), DashboardPaths.Energy);
  return (
    <PageContentAnimation className="flex flex-col gap-8">
      <DashboardFilters showOnlySpacesWithEosEnabled visiblePresets={eosDateRangeFilterVisiblePresets} />
      <WidgetsGrid>
        <TotalEnergyConsumptionWidget />
        <EnergyConsumptionKvmWidget />
        <ConsumptionTrendAverageWidget />
        <TopConsumptionWidget />
        <EstimatedEnergyCostWidget />
        <EstimatedEnergyCostSpacesWidget />
      </WidgetsGrid>
    </PageContentAnimation>
  );
}
